import React from "react";
import { Tab } from "semantic-ui-react";
import EndoTest from "../../EndoTest/index";

const EndotestContent = ({ data, putEndoAnswers }) => {
	return (
		<Tab.Pane style={{ marginTop: 20 }}>
			<EndoTest disabled={data.isDone} endoAnswers={data.endoAnswers} submit={putEndoAnswers} />
		</Tab.Pane>
	);
};
export default EndotestContent;
